module.exports = __webpack_public_path__ + "static/media/CC20-MB210-12.9a9f4f54.png";